<script lang="ts">
import { computed, inject, onActivated, ref, watch, defineComponent } from "vue";
import formatUtils from "@/businesslogic/utils/formatUtils";
import Modal from "@/components/Modal.vue";
import Zahlweise from "@/components/Zahlweise.vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "BeitragFH",
  components: { Zahlweise, Modal },
  emits: ["next-page"],
  setup(props, { emit }) {
    const piniaStore = useFormStore();
    const istSichtbar: any = inject("istSichtbar");
    const wechsleSichtbarkeit: any = inject("wechsleSichtbarkeit");
    const { formatCurrency, getZahlungsweiseAlsText } = formatUtils();
    const textZahlungsweise = ref("");

    const gesamtPreisGemZahlweiseFH = computed(() => {
      return piniaStore.state.preise.produktLinien.length > 0
        ? piniaStore.state.preise.produktLinien[piniaStore.state.preise.produktLinien.length - 1].gemZahlungsweise
        : 0;
    });
    const gesamtPreisJaehrlichFH = computed(() => {
      return piniaStore.state.preise.produktLinien.length > 0
        ? piniaStore.state.preise.produktLinien[piniaStore.state.preise.produktLinien.length - 1].jaehrlich
        : 0;
    });
    const gesamtPreisHalbjaehrlichFH = computed(() => {
      return piniaStore.state.preise.produktLinien.length > 0
        ? piniaStore.state.preise.produktLinien[piniaStore.state.preise.produktLinien.length - 1].halbjaehrlich
        : 0;
    });
    const gesamtPreisVieteljaehrlichFH = computed(() => {
      return piniaStore.state.preise.produktLinien.length > 0
        ? piniaStore.state.preise.produktLinien[piniaStore.state.preise.produktLinien.length - 1].vierteljaehrlich
        : 0;
    });
    const gesamtPreisMonatlichFH = computed(() => {
      return piniaStore.state.preise.produktLinien.length > 0
        ? piniaStore.state.preise.produktLinien[piniaStore.state.preise.produktLinien.length - 1].monatlich
        : 0;
    });
    const pruefeHalbjaehrlichFH = computed(() => {
      for (let i = 0; i <= piniaStore.state.preise.produktLinien.length - 1; i++) {
        if (piniaStore.state.preise.produktLinien[i].halbjaehrlich < 25.0) {
          return false;
        }
      }
      return true;
    });
    const pruefeVierteljaehrlichFH = computed(() => {
      for (let i = 0; i <= piniaStore.state.preise.produktLinien.length - 1; i++) {
        if (piniaStore.state.preise.produktLinien[i].vierteljaehrlich < 25.0) {
          return false;
        }
      }
      return true;
    });
    const pruefeMonatlichFH = computed(() => {
      for (let i = 0; i <= piniaStore.state.preise.produktLinien.length - 1; i++) {
        if (piniaStore.state.preise.produktLinien[i].monatlich < 25.0) {
          return false;
        }
      }
      return true;
    });
    const pruefeAufZahlweiseOptionen = computed(() => {
      return pruefeHalbjaehrlichFH;
    });

    function setTextZahlungsweise() {
      textZahlungsweise.value = getZahlungsweiseAlsText(piniaStore.state.tarifinformationen.zahlungsweise);
    }

    watch(
      () => piniaStore.state.tarifinformationen.zahlungsweise,
      () => {
        setTextZahlungsweise();
      },
    );

    watch(
      () => [pruefeHalbjaehrlichFH.value, pruefeVierteljaehrlichFH.value, pruefeMonatlichFH.value],
      () => {
        modalAnzeige();
      },
    );

    function modalAnzeige() {
      if (
        (!pruefeMonatlichFH.value && piniaStore.state.tarifinformationen.zahlungsweise == 12) ||
        (!pruefeVierteljaehrlichFH.value && piniaStore.state.tarifinformationen.zahlungsweise == 4) ||
        (!pruefeHalbjaehrlichFH.value && piniaStore.state.tarifinformationen.zahlungsweise == 2)
      ) {
        piniaStore.state.tarifinformationen.anpassungZahlungsweise = true; //für Step 5 Blauer Kasten (Rabatt Kernsanierung) gebraucht
        piniaStore.state.tarifinformationen.zahlungsweise = 1;
        wechsleSichtbarkeit("modal-mindestbeitrag-unterschritten");
      }
    }

    onActivated(() => {
      setTextZahlungsweise();
    });

    function nextPage() {
      emit("next-page");
    }

    return {
      props,
      piniaStore,
      istSichtbar,
      wechsleSichtbarkeit,
      formatCurrency,
      textZahlungsweise,
      gesamtPreisGemZahlweiseFH,
      gesamtPreisJaehrlichFH,
      gesamtPreisHalbjaehrlichFH,
      gesamtPreisVieteljaehrlichFH,
      gesamtPreisMonatlichFH,
      pruefeHalbjaehrlichFH,
      pruefeVierteljaehrlichFH,
      pruefeMonatlichFH,
      pruefeAufZahlweiseOptionen,
      nextPage,
    };
  },
});
</script>

<template>
  <div class="o-grid u-mar-t-1">
    <div
      class="o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480"
      style="margin-bottom: 0 !important"
    >
      <h2 class="u-form-heading unset-text-align">Tarif</h2>
    </div>
    <div
      class="o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200"
      style="margin-bottom: 0 !important"
    >
      <h2 class="u-form-heading u-text-align-left u-color-primary">
        <strong v-if="!piniaStore.state.isMakler">Schließen Sie Ihren individuellen Vorschlag jetzt ab</strong>
        <strong v-if="piniaStore.state.isMakler">Unser Vorschlag</strong>
      </h2>
    </div>
  </div>
  <div class="o-grid">
    <div
      class="o-grid__cell o-grid__cell--offset-3-768 o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200"
    >
      <div class="gev19-premium-order-box">
        <div class="o-grid">
          <div class="o-grid__cell o-grid__cell--0 o-grid__cell--6-480">
            <a
              id="changePayment"
              @click="wechsleSichtbarkeit('modal-zahlweise')"
              data-cy="changePaymentLink"
              v-if="pruefeAufZahlweiseOptionen"
            >
              Zahlungsweise ändern
            </a>
            <Modal
              v-if="istSichtbar('modal-zahlweise')"
              titel="Zahlungsweise ändern (Mindestrate 25€)"
              @closeModal="wechsleSichtbarkeit('modal-zahlweise')"
            >
              <template v-slot:inhalt>
                <div class="o-grid">
                  <Zahlweise
                    :zahlweise-feld-wert="1"
                    :zahlweise-beitrag="gesamtPreisJaehrlichFH"
                    zahlweise-text="Jährlich"
                  />
                  <Zahlweise
                    v-if="pruefeHalbjaehrlichFH"
                    :zahlweise-feld-wert="2"
                    :zahlweise-beitrag="gesamtPreisHalbjaehrlichFH"
                    zahlweise-text="Halbjährlich"
                  />
                  <div class="o-grid__cell o-grid__cell--1 o-grid__cell--4-480"></div>
                  <Zahlweise
                    v-if="pruefeVierteljaehrlichFH"
                    :zahlweise-feld-wert="4"
                    :zahlweise-beitrag="gesamtPreisVieteljaehrlichFH"
                    zahlweise-text="Vierteljährlich"
                  />
                  <Zahlweise
                    v-if="pruefeMonatlichFH"
                    :zahlweise-feld-wert="12"
                    :zahlweise-beitrag="gesamtPreisMonatlichFH"
                    zahlweise-text="Monatlich"
                  />
                  <div class="o-grid__cell o-grid__cell--1 o-grid__cell--4-480"></div>
                  <div class="o-grid__cell o-grid__cell--12 u-text-align-right">
                    <span
                      id="modalHideTariffPaymentFrequency"
                      class="c-button"
                      @click="wechsleSichtbarkeit('modal-zahlweise')"
                      data-cy="paymentFrequencySubmit"
                    >
                      Änderung übernehmen
                    </span>
                  </div>
                </div>
              </template>
            </Modal>
          </div>
          <div class="o-grid__cell o-grid__cell--0 o-grid__cell--6-480 u-text-align-right">
            {{ piniaStore.state.isMakler ? "Beitrag" : "Ihr Beitrag" }}
            {{ textZahlungsweise ? "/" + textZahlungsweise : "" }}
            <br />
            <h2 class="u-form-heading unset-text-align">
              {{ formatCurrency(gesamtPreisGemZahlweiseFH) }}
            </h2>
          </div>
          <div class="o-grid__cell o-grid__cell--12">
            <button
              v-bind:title="piniaStore.state.isMakler ? 'Diesen Tarif beantragen' : 'Weiter mit diesem Tarif'"
              id="btnChooseTariffSubmit"
              class="c-button c-button--full-width"
              data-cy="submitWeiterMitDiesemTarif"
              @click="nextPage()"
            >
              {{ piniaStore.state.isMakler === true ? "Diesen Tarif beantragen" : "Weiter mit diesem Tarif" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal für Mindestbetrag -->
  <modal
    v-if="istSichtbar('modal-mindestbeitrag-unterschritten')"
    titel="Information"
    text="Aufgrund Ihrer Änderungen wurde der Mindestbeitrag in Höhe von 25 € unterschritten. Die Zahlungsweise wurde daher auf jährlich umgestellt."
    :hat-schliessen-button="true"
    @closeModal="wechsleSichtbarkeit('modal-mindestbeitrag-unterschritten')"
  >
  </modal>
</template>

<style scoped></style>
